
export const logoURL = "https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png"

export const profileURL = "https://avatars.githubusercontent.com/u/104522305?s=400&u=ea57ba94d0c5ee98d789a52e402c2e470a9f4047&v=4"

export const backgroundURL = "https://assets.nflxext.com/ffe/siteui/vlv3/dae1f45f-c2c5-4a62-8d58-6e1b0c6b2d8e/6d1fb8a4-5844-42a4-9b01-1c6c128acf19/IN-en-20240827-TRIFECTA-perspective_WEB_c292a608-cdc6-4686-8dc8-405bfcf753af_large.jpg"

export const API_OPTIONS = {
    method: 'GET',
    headers: {
        accept: 'Bearerapplication/json',
        Authorization: `Bearer  ${process.env.REACT_APP_TMDB_KEY}`,
    }
};
export const SUPPORTED_LANGUAGES = [
    { identifier: 'en', name: "English" },
    { identifier: 'hn', name: "Hindi" },
    { identifier: 'spn', name: "Spanish" },
    { identifier: 'zpn', name: "Japanese" },
];

export const IMG_CDN_URL = "https://image.tmdb.org/t/p/w500/"


export const API_KEY_URL =process.env.REACT_APP_API_KEY; // Google gemini ai API key only for exampale

